import { Page } from '@web/newsfeed/types/Page';
import { Article } from '@web/newsfeed/types/Article';

export const mapAngularArticleToUI = (article: any): Article => {
  const { channel } = article;

  return {
    attachments: article.attachments,
    commentedByMe: article.commented,
    commentsCount: article.comments,
    content: article.content,
    id: article.id,
    likedByMe: article.liked,
    likesCount: article.likes,
    page: {
      id: channel.id,
      name: channel.name,
    },
    posted: article.posted,
    seenBy: article.seenby,
    user: article.user,
  };
};

export const mapAngularPageToUI = (page: any): Page => ({
  id: page.id,
  name: page.name,
  articles: page.articles.map(mapAngularArticleToUI),
  members: page.members?.map((member) => ({ id: member.id })),
});
